<template>
    <v-stepper :items="['Qualifications']" v-model="step" hide-actions mandatory alt-labels>
        <template v-slot:[`item.1`]>
            <QualificationsListView />
        </template>
    </v-stepper>
</template>

<script setup>
import { ref } from 'vue';
import QualificationsListView from './QualificationsListView.vue';

const step = ref(1);


</script>